import {Component} from '@angular/core';
import {NavController} from 'ionic-angular';
import {LoginPage} from '../login/login';
import {WelcomePage} from "../welcome/welcome";

@Component({
  selector: 'page-password-reset-sent',
  templateUrl: 'password-reset-sent.html'
})
export class PasswordResetSentPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }

  goToLogin(params) {
    if (!params) params = {};
    this.navCtrl.setRoot(WelcomePage);
    this.navCtrl.push(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/password-reset-sent/password-reset-sent.ts